import React from "react";

const PeopleSingleLarge = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 23.848C2 13.7559 24.1533 13.7559 24.1533 23.5923"
        stroke="var(--growth-color)"
        strokeWidth="2.5"
      />
      <circle
        cx="13.3238"
        cy="6.89215"
        r="5.64215"
        stroke="var(--growth-color)"
        strokeWidth="2.5"
      />
    </svg>
  );
};

export default PeopleSingleLarge;
